import _ from "lodash";
import $ from "jquery";
import axios from "axios";
window._ = _;
window.$ = $;
window.jQuery = $;
window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
let token = document.head.querySelector('meta[name="csrf-token"]');
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
}